<ng-template #sidenavContent>
  <div
    class="flex min-h-full flex-col gap-0 p-4 max-[768px]:min-h-auto max-[768px]:flex-row max-[768px]:items-center max-[768px]:gap-2 max-[768px]:px-3 max-[768px]:py-2"
    (mouseenter)="onMouseEnter()"
    (mouseleave)="onMouseLeave()"
  >
    <header
      class="-mx-4 -mt-4 mb-2 rounded-b-[0.65rem] px-4 pb-[0.875rem] pt-4 max-[768px]:hidden"
      [style.background]="headerBackground()"
      [style.color]="headerColor()"
      [class.bg-transparent]="isCollapsed() && !showBranding()"
      [class.text-inherit]="isCollapsed() && !showBranding()"
      [class.rounded-none]="isCollapsed() && !showBranding()"
      [class.-mx-2]="isCollapsed() && !showBranding()"
      [class.-mt-2]="isCollapsed() && !showBranding()"
      [class.mb-0]="isCollapsed() && !showBranding()"
      [class.px-0]="isCollapsed() && !showBranding()"
      [class.py-1]="isCollapsed() && !showBranding()"
    >
      @if (!isCollapsed()) {
        <div class="flex items-start gap-3">
          @if (showBranding()) {
            <div
              class="sidebar-logo-icon flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-[color-mix(in_srgb,var(--io-sidenav-header-fg,#fff)_14%,transparent)] text-sm font-bold tracking-[0.04em]"
            >
              @if (branding() === 'logo') {
                @if (logoSrc()) {
                  <img [src]="logoSrc()" [alt]="title() || logoText()" class="h-8 w-8 rounded-md object-contain" />
                } @else {
                  {{ logoText() }}
                }
              } @else {
                <i [class]="iconClass()"></i>
              }
            </div>
          }
          <div class="flex min-w-0 flex-1 flex-col gap-[0.15rem]">
            @if (title()) {
              <h2 class="m-0 text-base font-semibold leading-[1.25]">{{ title() }}</h2>
            }
            @if (subtitle()) {
              <p class="m-0 text-sm leading-[1.35] opacity-[0.88]">{{ subtitle() }}</p>
            }
          </div>
        </div>
        <span
          class="mt-3 block border-t border-t-[color-mix(in_srgb,var(--io-sidenav-header-fg,#fff)_22%,transparent)] pt-[0.65rem] text-xs leading-[1.4] opacity-[0.82]"
          >{{ menuHint() }}</span
        >
      } @else if (showBranding()) {
        <div class="flex items-start justify-center gap-3">
          <div
            class="sidebar-logo-icon flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-[color-mix(in_srgb,var(--io-sidenav-header-fg,#fff)_14%,transparent)] text-sm font-bold tracking-[0.04em]"
          >
            @if (branding() === 'logo') {
              @if (logoSrc()) {
                <img [src]="logoSrc()" [alt]="title() || logoText()" class="h-8 w-8 rounded-md object-contain" />
              } @else {
                {{ logoText() }}
              }
            } @else {
              <i [class]="iconClass()"></i>
            }
          </div>
        </div>
      }
    </header>

    <div
      class="flex min-h-0 flex-1 flex-col pt-3 max-[768px]:flex-[1_1_auto] max-[768px]:overflow-x-scroll max-[768px]:overflow-y-hidden max-[768px]:p-0 max-[768px]:[scrollbar-color:color-mix(in_srgb,var(--p-primary-color)_65%,#9f1239)_color-mix(in_srgb,var(--p-primary-color)_10%,var(--p-surface-100))] max-[768px]:[scrollbar-gutter:stable_both-edges] max-[768px]:[scrollbar-width:thin] max-[768px]:[&::-webkit-scrollbar-thumb]:rounded-[999px] max-[768px]:[&::-webkit-scrollbar-thumb]:bg-[color-mix(in_srgb,var(--p-primary-color)_72%,#9f1239)] max-[768px]:[&::-webkit-scrollbar-track]:rounded-[999px] max-[768px]:[&::-webkit-scrollbar-track]:bg-[color-mix(in_srgb,var(--p-primary-color)_10%,var(--p-surface-100))] max-[768px]:[&::-webkit-scrollbar]:h-[7px]"
    >
      @if (items().length && (!isCollapsed() || hasIcons())) {
        <nav
          class="flex flex-col gap-1 max-[768px]:w-max max-[768px]:min-w-[calc(100%+1rem)] max-[768px]:flex-row max-[768px]:flex-nowrap max-[768px]:items-center max-[768px]:justify-start max-[768px]:gap-[0.4rem] max-[768px]:pr-3 max-[768px]:pb-1"
          [class.items-center]="isCollapsed()"
          [class.py-2]="isCollapsed()"
          [class.gap-2]="isCollapsed()"
          aria-label="Navigation"
        >
          @for (item of items(); track $index) {
            @if (item.separator) {
              @if (!isCollapsed()) {
                <div
                  class="mt-4 mb-2 px-[0.65rem] text-xs font-bold uppercase tracking-wider opacity-70 text-[var(--p-text-color)]"
                >
                  {{ item.label }}
                </div>
              } @else {
                <div
                  class="mx-auto mt-4 mb-2 h-px w-6 bg-[color-mix(in_srgb,var(--p-content-border-color)_50%,transparent)]"
                ></div>
              }
            } @else {
              @if (!isCollapsed() || item.icon) {
                <button
                  type="button"
                  class="flex w-full cursor-pointer items-center gap-[0.6rem] rounded-[0.45rem] border-none bg-transparent px-[0.65rem] py-[0.55rem] text-left text-sm text-[var(--p-text-color)] transition-[background,color,box-shadow] duration-150 ease-in-out hover:bg-[var(--p-highlight-background)] hover:text-[var(--p-highlight-color)] max-[768px]:h-auto max-[768px]:w-auto max-[768px]:min-w-[4.8rem] max-[768px]:flex-[0_0_auto] max-[768px]:flex-col max-[768px]:justify-center max-[768px]:gap-1 max-[768px]:rounded-[0.65rem] max-[768px]:px-2 max-[768px]:py-[0.45rem] max-[768px]:text-xs"
                  [class.h-10]="isCollapsed()"
                  [class.w-10]="isCollapsed()"
                  [class.justify-center]="isCollapsed()"
                  [class.p-0]="isCollapsed()"
                  [class.rounded-lg]="isCollapsed()"
                  [class.font-semibold]="isItemActive($index)"
                  [style.background]="
                    isItemActive($index) ? 'color-mix(in srgb, var(--p-primary-color) 18%, transparent)' : null
                  "
                  [style.color]="isItemActive($index) ? 'var(--p-primary-color)' : null"
                  [style.boxShadow]="
                    isCollapsed() && isItemActive($index)
                      ? 'inset 0 0 0 2px var(--p-primary-color)'
                      : isItemActive($index)
                        ? 'inset 0 0 0 1px color-mix(in srgb, var(--p-primary-color) 35%, transparent)'
                        : null
                  "
                  (click)="onItemClick(item)"
                  [attr.aria-label]="item.label ?? ''"
                >
                  @if (item.icon) {
                    @if (item.icon.includes('/') || item.icon.includes('.svg')) {
                      <img
                        [src]="item.icon"
                        [alt]="item.label ?? 'menu icon'"
                        class="h-5 w-5 shrink-0 object-contain opacity-90 max-[768px]:h-4 max-[768px]:w-4"
                      />
                    } @else {
                      <i [class]="item.icon + ' w-5 shrink-0 text-center opacity-90 max-[768px]:w-auto'"></i>
                    }
                  }
                  <span [class.hidden]="isCollapsed()">
                    {{ item.label }}
                  </span>
                  <span
                    class="hidden min-w-0 flex-1 whitespace-nowrap max-[768px]:inline max-[768px]:text-xs max-[768px]:text-center max-[768px]:leading-[1.1]"
                  >
                    {{ item.label }}
                  </span>
                  @if (showItemBadge(item)) {
                    <span
                      class="io-sidenav-nav-badge ms-auto shrink-0 rounded-full px-[0.45rem] py-[0.2rem] text-[0.6875rem] font-semibold leading-none tabular-nums text-[var(--p-text-color)] max-[768px]:hidden"
                      aria-hidden="true"
                      >{{ item.badge }}</span
                    >
                  }
                </button>
              }
            }
          }
        </nav>
      }

      @if (!isCollapsed()) {
        <ng-content></ng-content>
      }

      <footer class="mt-auto shrink-0 px-0 pb-1 pt-4 max-[768px]:hidden">
        <button
          type="button"
          class="flex w-full cursor-pointer items-center justify-center gap-2 rounded-lg border border-[var(--p-content-border-color,var(--p-surface-300))] bg-[var(--p-surface-50,var(--p-surface-100))] px-3 py-[0.65rem] text-sm font-medium text-[var(--p-text-color)] transition-[background,border-color,color] duration-150 ease-in-out hover:border-[color-mix(in_srgb,var(--p-primary-color)_28%,var(--p-content-border-color))] hover:bg-[var(--p-highlight-background)] hover:text-[var(--p-highlight-color)]"
          [class.h-10]="isCollapsed()"
          [class.w-10]="isCollapsed()"
          [class.mx-auto]="isCollapsed()"
          [class.p-0]="isCollapsed()"
          (click)="closeDrawer()"
        >
          <i [class]="closeArrowClass()" aria-hidden="true"></i>
          @if (!isCollapsed()) {
            <span>{{ 'common.collapse' | translate }}</span>
          }
        </button>
      </footer>
    </div>
  </div>
</ng-template>

@if (embedded()) {
  <aside
    class="block h-full overflow-hidden border-r border-[var(--p-surface-300)] bg-[var(--p-surface-0)] transition-[width] duration-300 ease-[cubic-bezier(0.4,0,0.2,1)] max-[768px]:fixed max-[768px]:bottom-0 max-[768px]:left-0 max-[768px]:right-0 max-[768px]:top-auto max-[768px]:z-[1000] max-[768px]:h-auto max-[768px]:!w-full max-[768px]:border-r-0 max-[768px]:border-t max-[768px]:border-t-[var(--p-surface-300)]"
    [class.border-r-0]="status() === 'hidden'"
    [style]="embeddedStyle()"
  >
    <ng-container [ngTemplateOutlet]="sidenavContent"></ng-container>
  </aside>
} @else {
  <p-drawer
    [visible]="isVisible()"
    (visibleChange)="visible.set($event)"
    [position]="position()"
    [modal]="modal()"
    [dismissible]="dismissible()"
    [showCloseIcon]="showCloseIcon"
    [blockScroll]="blockScroll()"
    [styleClass]="computedStyleClass()"
    [style]="drawerStyle()"
  >
    <ng-container [ngTemplateOutlet]="sidenavContent"></ng-container>
  </p-drawer>
}
